import colors from "resources/theme/colors";
import { RiMailCloseFill } from "react-icons/ri";
import { SimpleGrid } from "@chakra-ui/layout";
import useDashboardEmail from "features/relatorios/hooks/useDashboardEmail";
import emailFast from "assets/images/svgs/email-fast.svg";
import emailNewsletter from "assets/images/svgs/email-newsletter.svg";
import emailOff from "assets/images/svgs/email-off.svg";
import Card2Horizontal from "components/Cards/Card2Horizontal";
import { Image } from "@chakra-ui/react";

interface DashboardEmailProps {
  filtros: any;
}

function DashboardEmail({ filtros }: DashboardEmailProps) {
  const { data: totais, isLoading } = useDashboardEmail(filtros);

  const enviados = totais?.enviados || 0;
  const erro = totais?.erro || 0;
  const visualizados = totais?.visualizados || 0;
  const naoVisualizados = totais?.naoVisualizados || 0;

  return (
    <>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} gap="16px" mb="32px">
        <Card2Horizontal
          icon={<Image src={emailFast} w="100%" h="16px" />}
          color={colors.blue}
          bg={colors.blue100}
          description="E-mails enviados"
          title={`${enviados}`}
          loading={isLoading}
        />

        <Card2Horizontal
          icon={<RiMailCloseFill fontSize="24px" color={colors.orange} />}
          color={colors.orange}
          bg={colors.orange50}
          description="E-mails com erro de envio"
          title={`${erro}`}
          loading={isLoading}
        />

        <Card2Horizontal
          icon={<Image src={emailNewsletter} />}
          color={colors.green}
          bg={colors.purple100}
          description="E-mails visualizados"
          title={`${visualizados}`}
          loading={isLoading}
        />

        <Card2Horizontal
          icon={<Image src={emailOff} />}
          color={colors.red}
          bg={colors.yellow100}
          description="E-mails não visualizados"
          title={`${naoVisualizados}`}
          loading={isLoading}
        />
      </SimpleGrid>
    </>
  );
}

export default DashboardEmail;
